import { ArnValidConditionConfig, UrlUtil } from '@arianee/arn-types';
import {
  ArnConditionConfig,
  ArnConditionConfigImpl,
} from './ArnConditionConfig';
import { ArnConditionService } from './ArnConditionService';
import { ArnHttpService } from '../http';
import { ArnConditionServiceFactory } from './ArnConditionServiceFactory';
import { DefaultConditionService } from './DefaultConditionService';
import { ArnAuthService } from '../auth';

export class DefaultConditionServiceFactory
  implements ArnConditionServiceFactory
{
  create(
    http: ArnHttpService,
    auth: ArnAuthService,
    spec?: ArnConditionConfig,
    baseUrl?: string
  ): ArnConditionService {
    const config = this.createConfig(spec, baseUrl);
    return new DefaultConditionService(http, auth, config);
  }

  createConfig(
    spec?: ArnConditionConfig,
    baseUrl?: string
  ): ArnValidConditionConfig {
    return new ArnConditionConfigImpl({
      url: UrlUtil.build(spec?.execute?.url, 'condition/execute', baseUrl),
    });
  }
}
